/* eslint-disable no-new */
import Flickity from "flickity"
import "flickity-as-nav-for"
import "flickity-imagesloaded"
import imagesLoaded from "imagesloaded"
import { kebabCase } from "lodash"
import $ from "jquery"
import "magnific-popup"
import { breakpoints } from "../utils"

const sliders = Array.from(document.querySelectorAll(".js-slider"))
// console.log("Test", sliders );
sliders.forEach((slider) => {
	if (slider.children.length > 1) {
		
		imagesLoaded(slider, () => {
			var flkty = new Flickity(slider, {
				wrapAround: true,
				pageDots: false,
			imagesLoaded: true, 
				on: {
					change: () => {
						const productName = slider.querySelector("a").dataset.name
						const contentName = slider.querySelector("a").dataset.content

						window.dataLayer.push({
							event: "carousel",
							productName: kebabCase(productName),
							contentName: kebabCase(contentName),
						})
					},
				},
			})
			// console.log(flkty, 'flktyrrrrr');
			// console.log(window, 'windowgggggg');
			flkty.on("cellSelect", () => {
				window.dataLayer.push({
					event: "carousel",
					productName: flkty.selectedElement.dataset.name,
					contentName: flkty.selectedElement.dataset.content,
					productCode: flkty.selectedElement.dataset.code,
				})
			})

			flkty.on("cellSelect", () => {
				window.dataLayer.push({
					event: "carousel",
					productName: flkty.selectedElement.dataset.name,
					contentName: flkty.selectedElement.dataset.content,
					productCode: flkty.selectedElement.dataset.code,
				})
			})
		})
	}

	$(slider).magnificPopup({
		delegate: ".slider__item",
		type: "image",
		gallery: {
			enabled: true,
		},
		removalDelay: 300,
		mainClass: "mfp-fade",
	})
})

const pageBuilderSliders = Array.from(document.querySelectorAll(".js-page-builder-slider"))
if (window.matchMedia(breakpoints["lap-and-up"]).matches) {
	const navForPageBuilderSliders = Array.from(document.querySelectorAll(".js-page-builder-slider-nav"))
	pageBuilderSliders.forEach((slider, i) => {
		imagesLoaded(slider, () => {
			new Flickity(slider, {
				wrapAround: true,
				pageDots: false,
				draggable: true,
			})

			new Flickity(navForPageBuilderSliders[i], {
				asNavFor: slider,
				contain: true,
				pageDots: false,
			})
		})
	})

} else {
	pageBuilderSliders.forEach((slider) => {
		imagesLoaded(slider, () => {
			new Flickity(slider, {
				wrapAround: true,
				pageDots: false,
				draggable: true,
			})
		})
	})
}